export default __webpack_public_path__ + "static/r3-07951e42c3bcfb1db016b5989b108060.png";